<template>
  <el-main>
    <!-- 類型選擇 -->
    <div style="font-size:25px">
      {{ this.sessionDate.substring(0, 10) }}
      <span
        ><el-button
          style="font-size:20px;border:none;color:#409EFF"
          @click="editDialog = true"
          ><i class="el-icon-edit"></i> 編輯</el-button
        >
      </span>
    </div>
    <div class="notice-div">
      <p style="color:#F56C6C">注意事項</p>
      <ol>
        <li style="margin:7px 0">
          勾選繳費並儲存後，系統將自動產生【准考證號碼】，如後續取消，准考證號碼將【備用不遞補】，直到【重新勾選繳費】再次啟用
          。
        </li>
        <li style="margin:7px 0">
          成績達70分，系統將視為考試合格，儲存後，將自動產生【證照號碼】，如後續改為不合格(69以下)，證照號碼將【備用不遞補】，直到【重新輸入合格分數】再次啟用
          。
        </li>
        <li style="margin:7px 0">依考試日為準，考前1個月系統自動關閉場次。</li>
        <li style="margin:7px 0">
          輸入考試地址並儲存後，系統將會自動發送考試地點公告信件給報名該場次的會員。
        </li>
        <li style="margin:7px 0">
          關於准考證號碼重複問題，系統將自動選取【報名日期】較晚的會員，更改替補為最新不重複之號碼
        </li>
        <li style="margin:7px 0;color:red">
          目前因伺服器原因，一次操作更新資料請少於40筆，以免寄信功能出錯。
        </li>
      </ol>
    </div>
    <div>
      <div>
        <el-radio v-model="radio" label="1" border
          >全部({{ this.unfilterList.length }})</el-radio
        >
        <el-radio v-model="radio" label="2" border
          >已繳費({{
            this.unfilterList.filter((x) => x.remitStatus).length
          }})</el-radio
        >
        <el-radio v-model="radio" label="3" border
          >未繳費({{
            this.unfilterList.filter((x) => !x.remitStatus).length
          }})</el-radio
        >

        <el-radio
          v-model="radio"
          label="4"
          border
          v-if="this.repeat.length > 0"
          style="color:red"
          >有({{ this.repeat.length }})位准考證號碼重複<i
            class="el-icon-warning"
          >
          </i
        ></el-radio>
        <span v-if="this.repeat.length > 0"
          ><el-button type="warning" @click="solveRepeat()"
            >一鍵排除<i class="el-icon-circle-check"></i></el-button
        ></span>
      </div>
    </div>

    <!-- 間隔 -->
    <br />
    <br />
    <el-row>
      <el-col :span="12"
        ><el-button
          icon="el-icon-delete-solid"
          style="margin:0 12px 0 0"
          @click="DeleteUserInfo()"
        ></el-button
        ><span> 選擇並刪除 </span></el-col
      >
      <el-col :span="12" align="right"
        ><i class="el-icon-search"></i
        ><el-input
          style="width:200px; margin:0 16px"
          v-model="search"
          placeholder="搜尋"
        />
        <el-button @click="exportDailog = true">匯出</el-button>
        <el-button type="primary" @click="submitDialog = true"
          >儲存並發布</el-button
        >
      </el-col>
    </el-row>

    <!-- 間隔 -->
    <br /><br />

    <el-table
      v-loading="loading"
      :data="examInfoData()"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      height="650"
      :default-sort="{
        prop: 'registDate,examLocation,examNumber,remitConfirm',
        order: 'descending',
      }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="報名人" fixed>
        <template slot-scope="scope">
          <el-button
            class="btn2href"
            @click="goUserInfo(scope.row.userId)"
            style="text-decoration:none;"
            >{{ scope.row.userName }}</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="報名日期" width="100" prop="registDate" sortable>
        <template slot-scope="scope">
          {{ scope.row.registDate.substring(0, 10).replace(/-/g, '/') }}
        </template>
      </el-table-column>
      <el-table-column label="證件照片" width="150">
        <template slot-scope="scope">
          <el-image
            fit="contain"
            style="width: 100px; height: 100px"
            :src="scope.row.photoUrl"
            :preview-src-list="[scope.row.photoUrl]"
          ></el-image>
          <a :href="scope.row.photoUrl" style="text-decoration:none;">下載</a>
        </template>
      </el-table-column>
      <el-table-column
        label="考試地點"
        width="150"
        prop="examLocation"
        sortable
      >
        <template slot-scope="scope">
          <!-- <el-select v-model="scope.row.examLocation" placeholder="請輸入地點">
            <el-option
              v-for="item in sunLocationList"
              :key="item.subLocation"
              :label="item.subLocation"
              :value="item.subLocation"
            >
            </el-option>
          </el-select> -->
          <el-input
            v-model="scope.row.examLocation"
            placeholder="請輸入地點"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="考試地址" width="300">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.examAddress"
            placeholder="請輸入地址"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="匯款人">
        <template slot-scope="scope">
          {{ scope.row.remitName }}
        </template>
      </el-table-column>
      <el-table-column label="匯款末5碼" width="100">
        <template slot-scope="scope">
          {{ scope.row.remitNumber }}
        </template>
      </el-table-column>
      <el-table-column label="匯款憑證" width="150">
        <template slot-scope="scope">
          <el-image
            fit="contain"
            style="width: 100px; height: 100px"
            :src="scope.row.remitUrl"
            :preview-src-list="[scope.row.remitUrl]"
          ></el-image>
          <a :href="scope.row.remitUrl" style="text-decoration:none;">下載</a>
        </template>
      </el-table-column>
      <el-table-column label="繳費" width="50">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.remitStatus"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        label="確認匯款"
        width="100"
        prop="remitConfirm"
        sortable
      >
        <template slot-scope="scope">
          <!-- <el-checkbox v-model="scope.row.remitConfirm"></el-checkbox> -->
          <div
            :class="
              scope.row.remitConfirm
                ? 'confirm-status-true'
                : 'confirm-status-false'
            "
          >
            <p v-if="scope.row.remitConfirm" style="color: green;">已確認</p>
            <p v-else style="color: red;">未確認</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="准考證號碼"
        width="120"
        prop="examNumber"
        sortable
      >
        <template slot-scope="scope">
          <p v-if="scope.row.remitStatus">{{ scope.row.examNumber }}</p>
          <s v-else class="info">{{ scope.row.examNumber }}</s>
        </template>
      </el-table-column>
      <el-table-column label="報到時間">
        <template slot-scope="">
          00:00
        </template>
      </el-table-column>
      <el-table-column label="考試成績">
        <template slot-scope="scope">
          <el-input v-model="scope.row.score" placeholder="請輸入數字" />
        </template>
      </el-table-column>
      <el-table-column label="證照號碼" width="110">
        <template slot-scope="scope">
          {{ scope.row.certNumber }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 50, 100, 500, 1000]"
        :page-size="pagesize"
        layout="total, sizes,prev, pager, next"
        :total="
          examInfo.filter(
            (data) =>
              !search ||
              data.userName.match(search) ||
              data.registDate.match(search) ||
              (data.examLocation === null ? '' : data.examLocation).match(
                search,
              ) ||
              (data.examAddress === null ? '' : data.examAddress).match(
                search,
              ) ||
              data.remitName.match(search) ||
              (data.remitNumber === null ? '' : data.remitNumber).match(
                search,
              ) ||
              (data.examNumber === null ? '' : data.examNumber).match(search),
          ).length
        "
        prev-text="上一頁"
        next-text="下一頁"
      >
      </el-pagination>
    </div>

    <!-- submitDialog -->
    <el-dialog
      title="編輯場次"
      :visible.sync="submitDialog"
      width="30%"
      :close-on-click-modal="false"
    >
      <ul>
        <li>繳費產生【准考證號碼】</li>
        <li>合格成績產生【證照號碼】</li>
      </ul>
      <el-alert
        title="以上兩項號碼若事後取消，號碼將備用不遞補，請確認再確認。"
        type="error"
        center
      >
      </el-alert>
      <br />
      <div class="formSubmitBtnBox">
        <el-button type="primary" @click="submitExamInfoList()"
          >儲存並發佈</el-button
        >
      </div>
    </el-dialog>

    <!-- editSessionFialog -->
    <el-dialog
      title="儲存後即將發佈"
      :visible.sync="editDialog"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data1.updateForm1.data"
        status-icon
        :rules="data1.updateForm1.rules"
        ref="data1UpdateForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.updateForm1.loading"
      >
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="data1.updateForm1.data.session"
            type="date"
            value-format="yyyy/MM/dd"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="" prop="">
          <el-alert
            v-show="data1.updateForm1.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.updateForm1.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="editDialog = false">取消</el-button>
            <el-button type="primary" @click="data1UpdateForm1Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- exportDailog -->
    <el-dialog
      title="選擇匯出項目"
      :visible.sync="exportDailog"
      width="30%"
      :close-on-click-modal="false"
    >
      <br />
      <div class="export-div">
        <el-row class="export-div-inside">
          <el-col :span="12"
            ><div>匯出篩選結果<br />(全部or已繳費or未繳費)</div></el-col
          >
          <el-col :span="12" align="right"
            ><el-button type="primary" @click="exportSelected()"
              >匯出</el-button
            ></el-col
          >
        </el-row>
      </div>
      <br />
      <div class="export-div">
        <el-row class="export-div-inside">
          <el-col :span="12"><div>匯出全部</div></el-col>
          <el-col :span="12" align="right"
            ><el-button type="primary" @click="exportAll()"
              >匯出</el-button
            ></el-col
          >
        </el-row>
      </div>
      <br />
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportDailog = false">關閉</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  C_ExamInfo_GetList,
  C_ExamInfo_UpdateList,
  C_ExamSession_Update,
  C_ExamSession_Get,
  C_ExamSubLocation_GetList,
  C_ExamInfo_ExamNumberRepeatSolve,
  C_ExamInfo_DeleteList,
  C_ExamInfo_ExportUrl,
} from '@/assets/js/api';

export default {
  data() {
    return {
      empty: '',
      currentPage: 1, // 默認顯示第一頁
      pagesize: 10, //    每頁顯示筆數
      repeat: [],
      sessionDate: '',
      radio: '1',
      search: '',
      examInfoLength: 1,
      selectedItem: '',
      submitDialog: false,
      editDialog: false,
      exportDailog: false,
      nowCategoryId: 1,
      categoryList: [],
      nowSessionId: 1,
      sunLocationList: [],
      examInfo: [],
      unfilterList: [],
      loading: true,
      multipleSelection: [],
      data1: {
        //   data: [],
        //   addForm1: {
        //     // dialogVisible: false,
        //     loading: false,
        //     formRef: 'data1AddForm1',
        //     errorMessage: '',
        //     data: {
        //       date: '',
        //       summarize: '',
        //       name: '',
        //       top: false,
        //       contentType: 'Text',
        //       attachmentFile: [],
        //       url: '',
        //     },
        //     rules: {
        //       date: [{ required: true, message: '請輸入日期' }],
        //       summarize: [
        //         { required: true, message: '請輸入消息內容' },
        //         { min: 1, max: 300, message: '消息內容必須在300個字元內' },
        //       ],
        //     },
        //   },
        updateForm1: {
          loading: false,
          formRef: 'data1UpdateForm1',
          errorMessage: '',
          data: {
            session: '',
          },
          rules: {
            session: [{ required: true, message: '請輸入日期' }],
          },
        },
      },
    };
  },

  mounted() {
    this.data1.updateForm1.data.session = this.$route.query.date
      .substring(0, 10)
      .replace(/-/g, '/');
    this.getExamInfoDataList();

    this.getSessionDate();

    this.getSessionList();

    // this.splitStr();
  },
  watch: {
    $route() {},
    radio() {
      if (this.radio === '2') {
        this.examInfo = this.unfilterList;
        this.examInfo = this.examInfo.filter((x) => x.remitStatus);
      } else if (this.radio === '3') {
        this.examInfo = this.unfilterList;
        this.examInfo = this.examInfo.filter((x) => !x.remitStatus);
      } else if (this.radio === '1') {
        this.examInfo = this.unfilterList;
      } else if (this.radio === '4') {
        this.examInfo = this.unfilterList;
        this.examInfo = this.repeat;
      }
    },
  },
  methods: {
    // splitStr() {
    //   // 多條件搜尋測試
    //   const beFilter = [
    //     { name: '小白', age: '18', city: '高雄' },
    //     { name: '小白', age: '18', city: '台北' },
    //     { name: '小白', age: '19', city: '台南' },
    //     { name: '小黑', age: '20', city: '宜蘭' },
    //   ];

    //   const searchStr = ' 高雄 18 小白';
    //   const splitStr = searchStr.split(' ');

    //   searchStr.forEach((element) => {
    //     beFilter.filter((x) => x.name.match(element) );
    //     // element == x.name && element == x.age && element == x.city
    //   });

    //   console.log(beFilter);
    //   console.log(splitStr);
    //   const gg = beFilter.filter(
    //     (x) => (x.name.match(splitStr[0]) || x.age.match(splitStr[0]) || x.city.match(splitStr[0]))
    //       .filter((x.name.match(splitStr[1]) || x.age.match(splitStr[1]) || x.city.match(splitStr[1])))
    //         && (x.name.match(splitStr[2]) || x.age.match(splitStr[2]) || x.city.match(splitStr[2])),
    //   );

    //   console.log(gg);
    // },

    examInfoData() {
      return this.examInfo
        .filter(
          (data) => !this.search
            || data.userName.match(this.search)
            || data.registDate.match(this.search)
            || (data.examLocation === null ? '' : data.examLocation).match(
              this.search,
            )
            || (data.examAddress === null ? '' : data.examAddress).match(
              this.search,
            )
            || data.remitName.match(this.search)
            || (data.remitNumber === null ? '' : data.remitNumber).match(
              this.search,
            )
            || (data.examNumber === null ? '' : data.examNumber).match(
              this.search,
            ),
        )
        .slice(
          (this.currentPage - 1) * this.pagesize,
          this.currentPage * this.pagesize,
        );
    },
    handleSizeChange(size) {
      this.pagesize = size;
      /* console.log(this.pagesize) */
    },
    // 点击第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      /* console.log(this.currentPage) */
    },

    exportAll() {
      window.open(`${C_ExamInfo_ExportUrl + 1}/${this.$route.query.session}`);
    },
    exportSelected() {
      window.open(
        `${C_ExamInfo_ExportUrl + this.radio}/${this.$route.query.session}`,
      );
    },
    checkRepeat() {
      const notRepeatSet = new Set();
      const repeatList = [];
      const examNumberNotNull = this.examInfo
        .filter((x) => x.examNumber !== null && x.examNumber !== '')
        .reverse();
      // console.log(examNumberNotNull);
      examNumberNotNull.filter((e) => (!notRepeatSet.has(e.examNumber)
        ? notRepeatSet.add(e.examNumber)
        : repeatList.push(e)));
      this.repeat = repeatList;
    },
    solveRepeat() {
      C_ExamInfo_ExamNumberRepeatSolve(this.repeat)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
          });
          this.getExamInfoDataList();
          this.checkRepeat();
        })
        .catch((err) => {
          this.$notify.error({
            title: '錯誤',
            message: err.response.data.message,
          });
        });
    },

    getSessionList() {
      C_ExamSubLocation_GetList()
        .then((res) => {
          this.sunLocationList = res.data.data;
          // console.log('this.sunLocationList');
          // console.log(this.sunLocationList);
        })
        .catch((err) => {
          this.$notify.error({
            title: '錯誤',
            message: err.response.data.message,
          });
        });
    },

    getExamInfoDataList() {
      C_ExamInfo_GetList(this.$route.query.session)
        .then((res) => {
          console.log(res.data.data);
          this.loading = false;
          this.examInfo = res.data.data;
          this.unfilterList = this.examInfo;
          this.checkRepeat();
        })
        .catch((err) => {
          console.log(err);
          // this.$notify.error({
          //   title: '無報名資料',
          //   message: err.response.data.message,
          // });
          this.examInfo = [];
          this.unfilterList = this.examInfo;
          this.loading = false;
        });
    },
    getSessionDate() {
      C_ExamSession_Get(this.$route.query.session)
        .then((res) => {
          // console.log(res.data.data);
          this.sessionDate = res.data.data.session;
        })
        .catch((err) => {
          this.$notify.error({
            title: '錯誤',
            message: err.response.data.message,
          });
        });
    },

    data1UpdateForm1Submit() {
      C_ExamSession_Update(
        this.$route.query.session,
        this.data1.updateForm1.data,
      )
        .then(() => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
          });
          this.getSessionDate();
          this.editDialog = false;
        })
        .catch((err) => {
          this.$notify.error({
            title: '錯誤',
            message: err.response.data.message,
          });
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    // 刪除 Dialog
    DeleteUserInfo() {
      if (this.multipleSelection.length < 1) {
        this.$confirm('請先選擇資料後再操作', '')
          .then(() => {})
          .catch(() => {});
      } else {
        this.$confirm(
          `確定刪除 ${this.multipleSelection.length} 筆資料嗎? *(會員匯款資料會一並刪除)`,
          '刪除',
        )
          .then(() => {
            this.ExamInfoDeleteListAPI();
          })
          .catch(() => {});
      }
    },
    // 刪除API
    ExamInfoDeleteListAPI() {
      const selectedIds = this.multipleSelection.map((x) => x.id);
      const jsonObj = { MultId: selectedIds };
      C_ExamInfo_DeleteList(jsonObj)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '刪除成功',
            type: 'success',
          });
        })
        .catch((err) => {
          this.$notify({
            title: '刪除失敗',
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.getExamInfoDataList();
        });
    },
    examInfoGetList() {},
    submitExamInfoList() {
      this.submitDialog = false;
      const loading = this.$loading({
        lock: true,
        text: '資料更新中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      C_ExamInfo_UpdateList(this.examInfo)
        .then((res) => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
          });
          this.getExamInfoDataList();
          loading.close();
          console.log(res.data.message);
        })
        .catch((err) => {
          console.log(err);
          this.$notify.error({
            title: '錯誤',
            message: err.response.data.message,
          });
          loading.close();
        });
    },

    goAlbum(newsId) {
      this.$router.push({ name: '/group/news/album', params: { id: newsId } });
    },
    goUserInfo(userId) {
      const newTabUrl = this.$router.resolve({ path: `userInfo/${userId}` }).href;
      window.open(newTabUrl, '_blank');
    },
  },
};
</script>

<style lang="scss">
.confirm-status-false {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 8px;
  width: 61px;
  height: 32px;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  box-sizing: border-box;
  border-radius: 4px;
}
.confirm-status-true {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 8px;
  width: 61px;
  height: 32px;
  background: #f5fef0;
  border: 1px solid #e2fde6;
  box-sizing: border-box;
  border-radius: 4px;
}
.notice-div {
  padding: 5px 15px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #0089fa10;
  margin: 20px 0;
}
.export-div {
  padding: 24px;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.export-div-inside {
  align-items: center;
  display: flex;
  order: 1;
  margin: 16px 0px;
}

.pagination {
  margin: 10px 0 0 0;
  text-align: center;
}

.btn2href {
  padding: 0;
  border: none;
  color: rgba(38, 0, 255, 0.884);
}
</style>
